import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/doctor', label: 'Our Doctor' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="navigation-header">
      <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Logo */}
          <Link to="/" className="navigation-logo" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <img 
              src="/logo-tec.png" 
              alt="The Eternal Care Logo" 
              style={{ 
                height: '40px',
                width: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))'
              }}
            />
            <span>The Eternal Care</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav" >
            <ul className="navigation-menu">
              {navigationLinks.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className={`navigation-link ${isActive(link.path) ? 'active' : ''}`}
                        onClick={() => {
                        if (typeof window !== 'undefined' && window.gtag) {
                  
                          let eventName = `${link.label.toLowerCase().replace(/\s+/g, '_')}_click`;
                  
                          window.gtag('event', eventName, {
                            event_category: 'navigation',
                            event_label: link.label,
                            page_path: link.path,
                            page_title: document.title
                            });
                          }
                        }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
            </ul>
          </nav>

          {/* Utilities */}
          <div className="navigation-utilities">
                    <a
          href={`tel:${clinicInfo.phone}`}
          onClick={() => {
            if (typeof window !== 'undefined' && window.gtag) {
              window.gtag('event', 'phone_click', {
                event_category: 'conversion',
                event_label: 'Header Phone Click',
                page_path: window.location.pathname,
                page_title: document.title
              });
            }
          }}
              className="utility-link"
              style={{ display: 'none' }}
              aria-label="Call us"
            >
              <Phone size={18} />
            </a>
            <a
              href={clinicInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="utility-link"
              style={{ display: 'none' }}
              aria-label="Instagram"
              onClick={() => {
              if (typeof window !== 'undefined' && window.gtag) {
                window.gtag('event', 'instagram_click', {
                  event_category: 'social',
                  event_label: 'Header Instagram Click',
                  page_path: window.location.pathname,
                  page_title: document.title
                });
              }
            }}
            >
              <Instagram size={18} />
            </a>
                          <Link
                to="/book-appointment"
                className="btn-primary"
                style={{ display: 'none' }}
                onClick={() => {
                  if (typeof window !== 'undefined' && window.gtag) {
                    window.gtag('event', 'appointment_click', {
                    event_category: 'conversion',
                    event_label: 'Header Appointment Button',
                    page_path: window.location.pathname,
                    page_title: document.title
                  });
                  }
                }}
              >
              Book Appointment
            </Link>
            
            {/* Mobile Menu Toggle */}
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="mobile-nav">
            <ul className="mobile-menu">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`mobile-link ${isActive(link.path) ? 'active' : ''}`}
                    onClick={() => {
                      setMobileMenuOpen(false);
              
                      if (typeof window !== 'undefined' && window.gtag) {
                        let eventName = `${link.label.toLowerCase().replace(/\s+/g, '_')}_click`;
                          
                        window.gtag('event', eventName, {
                          event_category: 'navigation',
                          event_label: link.label,
                          page_path: link.path,
                          page_title: document.title
                        });
                      }
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                              <Link
                to="/book-appointment"
                className="mobile-link-cta"
                onClick={() => {
                  setMobileMenuOpen(false);
              
                  if (typeof window !== 'undefined' && window.gtag) {
                    window.gtag('event', 'appointment_click', {
                      event_category: 'conversion',
                      event_label: 'Mobile Appointment Button',
                      page_path: window.location.pathname,
                      page_title: document.title
                    });
                  }
                }}
              >
                  Book Appointment
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>

      <style jsx>{`
        .desktop-nav {
          display: block !important;
        }
        
        .utility-link {
          display: flex !important;
          align-items: center;
          color: var(--text-primary);
          transition: opacity 0.2s ease;
        }
        
        .utility-link:hover {
          opacity: 0.7;
        }

        .btn-primary {
          display: inline-flex !important;
        }

        .mobile-menu-toggle {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
          color: var(--text-primary);
          padding: 8px;
        }

        .mobile-nav {
          display: none;
          padding: 24px 0;
          border-top: 1px solid var(--border-light);
        }
        
        .navigation-logo {
          font-size: 18px;
          font-weight: 600;
          color: var(--text-primary);
          text-decoration: none;
        }

        .mobile-menu {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .mobile-link {
          display: block;
          padding: 16px 0;
          color: var(--text-primary);
          text-decoration: none;
          font-size: 16px;
          font-family: 'Suisse Medium', sans-serif;
          border-bottom: 1px solid var(--border-light);
        }

        .mobile-link.active {
          color: var(--interactive-hover);
        }

        .mobile-link-cta {
          display: block;
          margin-top: 16px;
          padding: 16px;
          text-align: center;
          background: var(--interactive-base);
          color: var(--bg-primary);
          text-decoration: none;
          font-family: 'Suisse Medium', sans-serif;
          font-weight: 700;
        }

        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }

          .navigation-utilities .utility-link,
          .navigation-utilities .btn-primary {
            display: none !important;
          }

          .mobile-menu-toggle {
            display: block;
          }

          .mobile-nav {
            display: block;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
